<template>
  <b-button class="ling-toggle-details d-flex align-items-center" variant="link">
    <div>
      <slot name="default">
        {{ label }}
      </slot>
    </div>
    <div class="ml-2 lpc-toggle-arrow">
      <i class="fas fa-chevron-right"></i>
    </div>
  </b-button>
</template>
<style lang="scss">
  .ling-toggle-details {
    &:hover, &:focus, &:active {
      text-decoration: none;
    }

    .lpc-toggle-arrow i {
      transition: transform .3s ease-in-out;
    }

    &.collapsed > .lpc-toggle-arrow i {
      transform: rotate(0deg);
    }

    &.not-collapsed > .lpc-toggle-arrow i {
      transform: rotate(90deg);
    }
  }
</style>
<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: 'Részletek'
    }
  }
}
</script>